import Vue from "vue";
import Router from "vue-router";
import Home from "../views/backstageManagement/home";
import Login from "../views/backstageManagement/login";
// import echarts from "echarts";
// Vue.prototype.$echarts = echarts;

Vue.use(Router);

export default new Router({
  routes: [
      {
        path: '/',
        name: 'Index',
        component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue')
      },
      {
        path: '/index',
        name: 'Index',
        component: () => import(/* webpackChunkName: "about" */ '../views/Index.vue')
      },
      {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
      },{
        path: '/newstendency',
        name: 'newstendency',
        component: () => import(/* webpackChunkName: "about" */ '../views/newstendency.vue')
      },{
        path: '/aboutUs',
        name: 'aboutUs',
        component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs.vue')
      },{
        path: '/recruitInfo',
        name: 'recruitInfo',
        component: () => import(/* webpackChunkName: "about" */ '../views/recruitInfo.vue')
      },{
        path: '/recruitDetail',
        name: 'recruitDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/recruitDetail.vue')
      },{
        path: '/newsDetail',
        name: 'newsDetail',
        component: () => import(/* webpackChunkName: "about" */ '../views/newsDetail.vue')
      },
      // 加盟合作
      {
        path: '/cooperation',
        name: 'cooperation',
        component: () => import(/* webpackChunkName: "about" */ '../views/cooperation.vue')
      },
      // 业务介绍
      {
        path: '/businessIntroduce',
        name: 'businessIntroduce',
        component: () => import(/* webpackChunkName: "about" */ '../views/businessIntroduce.vue')
      },
      // 产品中心
      {
        path: '/productCenter',
        name: 'productCenter',
        component: () => import(/* webpackChunkName: "about" */ '../views/productCenter.vue')
      },
      // 企业信息
      {
        path: '/companyInfo',
        name: 'companyInfo',
        component: () => import(/* webpackChunkName: "about" */ '../views/companyInfo.vue')
      },
    //登录
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
      // beforeEnter:(to,from,next)=>{
      //   //console.log(to,from);
      //   if(JSON.parse(window.sessionStorage.getItem('user'))){
      //     next();
      //   }else{
      //     next('/login');
      //   }
        
      // },
      children: [

        //新闻发布
        {
          path: "/news",
          name: "news",
          component: () => import("../views/backstageManagement/news.vue")
        },
        //系统维护
        {
          path: "/system",
          name: "system",
          component: () => import("../views/backstageManagement/system.vue")
        }
      ]
    }
  ]
});
